
import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { TrendingUp } from "lucide-react";
import { motion } from "framer-motion";

export default function StatsCard({ title, value, icon: Icon, gradient, trend, iconColor, borderColor }) {
    return (
        <motion.div
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
            className="group"
        >
            <Card className={`overflow-hidden transition-all duration-300 border border-transparent ${borderColor || 'hover:border-slate-600'}`} style={{ background: '#1A1D24' }}>
                <CardContent className="p-6">
                    <div className="flex justify-between items-start">
                        <div>
                            <p className="text-sm font-medium text-gray-400 mb-1">{title}</p>
                            <p className="text-3xl font-bold text-white mb-2">{value}</p>
                        </div>
                        <div className={`p-3 rounded-xl bg-slate-800/50 transition-all duration-300 group-hover:bg-gradient-to-r ${gradient}`}>
                            <Icon className={`w-6 h-6 transition-colors duration-300 ${iconColor || 'text-slate-400'} group-hover:text-white`} />
                        </div>
                    </div>
                    {trend && (
                        <div className="flex items-center text-sm">
                            <TrendingUp className="w-4 h-4 mr-1 text-emerald-400" />
                            <span className="text-emerald-400 font-medium">{trend}</span>
                        </div>
                    )}
                </CardContent>
            </Card>
        </motion.div>
    );
}
